'use client';
import { Dispatch, createContext } from 'react';

export interface AlertProps {
  title?: string;
  message?: string;
  ctaUrl?: string;
  severity?: 'error' | 'success' | 'info' | 'warning';
  duration?: number;
  show: boolean;
}

export const AlertContext = createContext<Dispatch<AlertProps>>(() => {});
